import { Link } from "react-router-dom";
import { MENU_ROUTES } from "../../config/menuRoutes";
import { privateRoutePaths } from "@/routes/private.route.config";
import { useAuth } from "@/AuthProvider";
import roles from "@/constant/roles.config";

const CreditExceed = (props) => {
    const { user, isEndUser, isSuperAdmin, isViewer, isPreKYCUser, isDemoUser } = useAuth();
    const getPrefix = () => {
        if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
        if (user && isDemoUser) return roles.DEMO.prefix;
        if (user && isEndUser) return roles.END_USER.prefix;
        if (user && isViewer) return roles.VIEWER.prefix;
        return roles.SUPER_ADMIN.prefix;
    };

    return (<>

        <div className='text-center'>
            <b>
                Profile View Limit Exceeded.
            </b></div>
        <div className='text-center'>
            You’ve hit your daily limit for viewing profiles. For further access or questions, contact your admin or reach out to <a href={`mailto:${process.env.REACT_APP_SUPPORT_MAIL}`}>{process.env.REACT_APP_SUPPORT_MAIL}.</a>
        </div>
        <div className="text-center my-3">
            {props.isSticky && <Link to={`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`}>
                <button type="button" className="btn-regi">Go to Dashboard</button>
            </Link>
            }
        </div>
    </>)
}

export default CreditExceed;